import { cn as e } from "../shared/utils.js";
import { Popover as t } from "./primitive/index.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/popover/compound-popover.tsx
function i({ align: i = "center", arrowProps: a, children: o, className: s, label: c, labelClassName: l, popoverClassName: u, popupProps: d, portalProps: f, positionerProps: p, rootProps: m, showArrow: h = !0, side: g = "top", triggerProps: _, wrapperClassName: v }) {
	return /* @__PURE__ */ n(t.Root, {
		...m,
		children: /* @__PURE__ */ r("div", {
			className: e("flex items-center", v),
			children: [/* @__PURE__ */ n(t.Trigger, {
				..._,
				className: s,
				children: o
			}), /* @__PURE__ */ n(t.Portal, {
				...f,
				children: /* @__PURE__ */ n(t.Positioner, {
					align: i,
					side: g,
					...p,
					children: /* @__PURE__ */ r(t.Popup, {
						...d,
						className: e("w-fit", u),
						children: [h && /* @__PURE__ */ n(t.Arrow, { ...a }), /* @__PURE__ */ n("div", {
							className: l,
							children: c
						})]
					})
				})
			})]
		})
	});
}
var a = Object.assign(i, t);
//#endregion
export { i as CompoundPopover, a as Popover };
